/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-02 11:24:30
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:19:33
 */
export default [
  {
    path: '/customer/list',
    name: 'customer-list',
    meta: {
      name: '顾客列表',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "customer" */ '@/views/customer/list/index.vue')
  },
  {
    path: '/customers/notice',
    name: 'customers-notice',
    meta: {
      name: '顾客通知',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "customer" */'@/views/customer/notice/index.vue')
  },
  {
    path: '/notice/detail/:id',
    name: 'notice-detail',
    meta: {
      name: '活动详情',
      parentsName: 'customers-notice',
      backName: 'customers-notice',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "customer" */'@/views/customer/notice/detail.vue')
  },
  {
    path: '/notice/add',
    name: 'notice-new',
    meta: {
      parentsName: 'products-info',
      name: '新建活动',
      backName: 'customers-notice',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "customer" */'@/views/customer/notice/handle.vue')
  },
  {
    path: '/notice/edit/:id',
    name: 'notice-edit',
    meta: {
      parentsName: 'products-info',
      backName: 'customers-notice',
      name: '编辑活动',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "customer" */'@/views/customer/notice/handle.vue')
  },
  {
    path: '/customer/detail/:email',
    name: 'customer-detail',
    meta: {
      parentsName: 'customer-list',
      backName: 'customer-list',
      name: '顾客详情',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "customer" */'@/views/customer/detail/index.vue')
  },
  {
    path: '/customer/manager',
    name: 'customer-manager',
    meta: {
      name: '顾客设置',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "customer" */'@/views/customer/manager/index.vue')
  },
]
